<template>
    <div class="flats-crm-filter-mobile" :class="{'open' : filterVisible}">
        <div class="flats-filtter-container">
            <flatsFilter class="filter-mobile-params" :mobileView="true"></flatsFilter>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
	import flatsFilter from '@/components/flats-crm/flats-crm-filter.vue'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'sale-CRM-flats-filter-mobile',
        components: {
            flatsFilter,
            svgIcon,
        },
        data () {
            return {
                filterData: null,
                count: 0,
            }
        },
        computed: mapGetters({
            filterVisible: 'loadVisibleFilterMobile',
            banerTopCoockieVisible: 'loadCockieBanerTopVisible',
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            paginPageNumber: 'loadPaginPageNumber',
            resetModeTrigger: 'loadResetTriggerMove',
        }),
        methods: {
            closeFilterMobile() {
                window.body.removeClass('overflowTrue');
                document.getElementById('header').classList.remove('notvisibleSalesLand');
                document.getElementById('footer').classList.remove('notvisibleSalesLand');
				this.$store.commit('SetVisibleFilterMobile', false);
            },
            resetFilterCrm() {
                this.count = this.count + 1;
                this.filterData = {
                    complexCodes: [this.salesCard.crm_code],
                    roomQuantities: [],
                    areaFrom: this.salesCard.filter_set_size.min,
                    areaTo: this.salesCard.filter_set_size.max,
                    floorRangeStart: this.salesCard.filter_set_floor.min,
                    floorRangeEnd: this.salesCard.filter_set_floor.max,
                    meterPriceFrom: this.salesCard.filter_set_money.min,
                    meterPriceTo: this.salesCard.filter_set_money.max,
                    linesOnPage: 12,
                    pageNumber: 1,
                };
                this.$store.commit('UpdatePaginPageNumber', 1);
                this.$store.commit('setFlatsFilterData', this.filterData);
                this.$store.dispatch('getFlatsByFilter', this.filterData);
                this.closeFilterMobile();
                this.$store.commit('TriggerResetFilterMove', this.count);
            },
        },
        beforeCreate() {
        },
        created () {
            this.closeFilterMobile();
        },  
        mounted () {
        }
    }
</script>

<style lang="scss">
    // @import '@/styles/components/flats-crm/flats-crm-filter.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-filter-mobile.scss';
</style>